import { OracleConversationMarkdown } from '@modules/oracle/components/OracleConversationMarkdown';
import {
  constructMarkdownFromAssistantResponseToken,
  getAssistantResponseEqlType,
  trackWisdomEvents,
} from '@modules/oracle/utils';
import { getMarkdownForChatResponse } from '@modules/oracle/utils/getMarkdownForChatResponse';
import { Box, Stack } from '@mui/material';
import { AssistantResponseTokenV2 } from 'generated/graphql';
import { useState } from 'react';

interface WisdomConversationStepAnswerProps {
  assistantResponseTokenV2List: AssistantResponseTokenV2[];
  promptID: string;
  stepID: string;
  isLoading: boolean;
  hasFinalAnswer: boolean;
  isResponseHalted: boolean;
}

export const WisdomConversationStepAnswer = ({
  assistantResponseTokenV2List,
  promptID,
  stepID,
  isLoading,
  hasFinalAnswer,
  isResponseHalted,
}: WisdomConversationStepAnswerProps) => {
  const markdown = constructMarkdownFromAssistantResponseToken({
    tokenToMarkdownConverter: getMarkdownForChatResponse,
    assistantResponseTokenV2List: assistantResponseTokenV2List,
  });

  const [shouldSkipTypingAnimation] = useState(!isLoading);

  const eqlResponseType = getAssistantResponseEqlType(
    assistantResponseTokenV2List,
  );

  const isQuantifyResponse = eqlResponseType === 'quantify';
  const isSummaryResponse = eqlResponseType === 'summary';

  // Instead we render "Inspect" button in parent component
  if (hasFinalAnswer && (isQuantifyResponse || isSummaryResponse)) {
    return null;
  }

  const onCopy = () => {
    const selectedText = window.getSelection()?.toString();

    trackWisdomEvents({
      eventName: 'Wisdom - Manually Copy Response',
      response: selectedText,
      copiedFrom: 'steps',
    });
  };

  return (
    <Stack>
      <Box onCopy={onCopy}>
        <OracleConversationMarkdown
          promptID={promptID}
          stepID={stepID}
          markdown={markdown}
          isLoading={isLoading}
          shouldSkipTypingAnimation={shouldSkipTypingAnimation}
        />
      </Box>
    </Stack>
  );
};
